import { LinearProgress } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'fixed',
      width: '100%',
      height: '100%',
      zIndex: 10000,
      marginTop: theme.spacing(-9.5),
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(-8.5)
      },
      paddingBottom: theme.spacing(2),
      textAlign: 'center',
      cursor: 'wait'
    }
  })
);

export default function InProgressBar({ message }: { message?: string }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress />
      <p>{message}</p>
    </div>
  );
}
